import { put, take } from 'redux-saga/effects'

import { actions } from './actions'
import { constants } from './constants'

export function* callSaga(params) {
  yield put(actions.findOrderProducts(params))
  yield take([constants.FIND_ORDER_PRODUCTS_SUCCESS, constants.FIND_ORDER_PRODUCTS_FAILED])
}
